import { Component, Prop, Vue } from "vue-property-decorator";
@Component
class CoinContent extends Vue {
  @Prop()
  private appName: any;
  @Prop()
  private val: any;

  public render() {
    const text_style = `color: rgb(140, 140, 140);line-height: 24px;margin-bottom: 4px;`
    const container_style = `display: flex;flex-direction: column;text-align: left;margin-bottom: 20px;`;
    return (
      <div style={container_style}>
        <p style={text_style}>To continue, {this.appName} need to access {
          this.val === "photo" ? "photos on your device" : "camera to take photos"
        }. </p>
      </div>
    );
  }
}

export default CoinContent;
